export default {
    'primary' : "Parisienne, cursive",
    'secondary' : "PT Sans, sans-serif"
}